import type { HelpFile } from '../../types/help'
import { ProvisioningTasksTestIds } from '../../../testids/ProvisioningTasksTestIds'

export const provisioningTasksHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-tasks',
  texts: {
    [ProvisioningTasksTestIds.provisioningTasksList]: 'Individual provisioning operations queued for target systems — one row per Enforcement Object change for one identity on one target system.',
    [ProvisioningTasksTestIds.colAccount]: 'Account on the target system to be modified by this task.',
    [ProvisioningTasksTestIds.btnRefresh]: null,
    [ProvisioningTasksTestIds.checkSelectAll]: 'Select every FAILED task on this page for bulk retry. Non-FAILED rows stay unselected.',
    [ProvisioningTasksTestIds.btnBulkRetry]: 'Retry every selected FAILED task. Opens a confirmation dialog showing the count and the active target-system filter.',
    [ProvisioningTasksTestIds.bulkRetryDialogTitle]: null,
  },
}
